import React from 'react'
import PropTypes from 'prop-types'
import Player from '@app/components/Player'
import Api from '@app/api'
import { Helmet } from 'react-helmet'

const Examples = ({ route: { history, match: { params: { id } } } }) => {
  const handleBack = () => history.replace('/')

  return (
    <div className="layout layout--public layout--forced-landscape">
      <Helmet>
        <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1" />
      </Helmet>
      <Player
        src={Api.examples.routes.resourceURL(id)}
        onBack={handleBack}
      />
    </div>
  )
}

Examples.propTypes = {
  route: PropTypes.object.isRequired
};

export default Examples
